"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONE_DAY_IN_MILLS = void 0;
exports.daysFrom = daysFrom;
exports.toMillis = toMillis;
exports.ONE_DAY_IN_MILLS = 24 * 60 * 60 * 1000;
function daysFrom(fromTime, daysDelta) {
    return fromTime + daysDelta * 24 * 60 * 60 * 1000;
}
function toMillis(timestamp) {
    return timestamp instanceof Date
        ? timestamp.getTime()
        : timestamp.toDate().getTime();
}
//# sourceMappingURL=date.js.map